module.exports = __webpack_public_path__ + "img/france-logo-icon.7fbd74b2.png";